<div class="prices-preview">
  <p *ngIf="loading">Loading Prices...</p>
  <div *ngIf="!loading">
    <table>
      <tbody>
        <tr *ngFor="let markup of prices">
          <td>{{ markup.label }}</td>
          <td>{{ markup.value }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
